// ============================================================
// BLACK OWL - Firebase Configuration
// ============================================================
// This connects your React app directly to Firestore
// for real-time updates across all screens.
// ============================================================

import { initializeApp } from "firebase/app";
import { initializeFirestore, collection, doc, onSnapshot, query, orderBy, where } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBjfBAZ9lt_apzAtFcRNpdg84jkA-aM5_8",
  authDomain: "black-owl-app.firebaseapp.com",
  projectId: "black-owl-app",
  storageBucket: "black-owl-app.firebasestorage.app",
  messagingSenderId: "271276966302",
  appId: "1:271276966302:web:6cafdeff4c1f6ec263968f"
};

const app = initializeApp(firebaseConfig);

// Use initializeFirestore with experimentalAutoDetectLongPolling
// This dramatically improves latency on Safari (iOS/macOS) which has
// known issues with the default WebChannel/WebSocket transport.
// Auto-detect keeps WebChannel fast paths on Chrome/Firefox but
// falls back to long-polling immediately when Safari struggles.
const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
});

export { db, collection, doc, onSnapshot, query, orderBy, where };
